import React from 'react';
import { PRODUCT, SUPPORT_EMAIL } from '../data/constants';
export function Footer() {
  return <footer className="border-t-4 border-tech bg-navy py-4" data-id="element-60" data-mp="3gfsjo3v2keir">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-61" data-mp="3gh3qkcjta2e3">
        <p className="text-xs font-semibold leading-snug text-white/85 sm:text-sm" data-id="element-62" data-mp="32ovz90bar3ms">
          © 2026 {PRODUCT} — All Rights Reserved.
        </p>
        <p className="mt-1 text-xs leading-snug text-white/70 sm:text-sm" data-id="element-63" data-mp="36n3c3k2n3ksp">
          {PRODUCT} is an independent educational and professional reference resource. It is not
          an official AWS, ASME, ISO, or CSWIP certification program and does not provide
          inspection qualification, code approval, or guaranteed inspection outcomes. Always
          consult current applicable welding codes, approved inspection procedures, project
          specifications, and qualified inspection personnel before making welding acceptance,
          rejection, or repair decisions.
        </p>
        <p className="mt-1.5 text-xs font-semibold uppercase tracking-wide text-white/70 sm:text-sm" data-id="element-64" data-mp="2evx98vvjb8zq">
          Terms &amp; Conditions • Privacy Policy • Contact
        </p>
        <p className="mt-1 text-xs text-white/70 sm:text-sm" data-id="element-65" data-mp="3gc0gzizjds73">
          Support:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-white underline decoration-tech underline-offset-2 transition-colors duration-150 ease-out hover:text-gold" data-id="element-66" data-mp="3v8hp81cfiqpf">
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </footer>;
}